var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShow)?_c('div',{staticClass:"apple-component-container icon-circle-wrapper",class:{ mastery: _vm.mastery },on:{"click":_vm.authenticate}},[(_vm.mastery)?_c('icon',{attrs:{"name":"apple-icon"}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }